// Tuesday to Sunday, 11:00 to 19:00, America/Denver. Closed Mondays.
export const HOURS = { open: 11, close: 19, closedDays: [1] };

export function denverNow() {
  const parts = new Intl.DateTimeFormat("en-US", { timeZone: "America/Denver", weekday: "short", hour: "numeric", minute: "numeric", hour12: false }).formatToParts(new Date());
  const get = (t) => parts.find((p) => p.type === t)?.value;
  const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return { day: days.indexOf(get("weekday")), h: Number(get("hour")) % 24, m: Number(get("minute")) };
}

/** Returns { open: bool, label: string } describing right now. */
export function openStatus() {
  const { day, h, m } = denverNow();
  const t = h + m / 60;
  if (HOURS.closedDays.includes(day)) return { open: false, label: "Closed today (Mondays). Back tomorrow at 11." };
  if (t < HOURS.open) return { open: false, label: `Opens today at 11 am` };
  if (t < HOURS.close) {
    const left = HOURS.close - t;
    if (left <= 1) return { open: true, label: "Open, kitchen closes at 7" };
    if (t >= 14 && t < 17) return { open: true, label: "Open now. Quiet hours, short wait" };
    return { open: true, label: "Open now until 7" };
  }
  return { open: false, label: day === 0 ? "Closed for the night. Closed Mondays, back Tuesday at 11." : "Closed for the night. Back tomorrow at 11." };
}
